module.exports = __webpack_public_path__ + "img/yanfatuandui.43355fb2.png";